import { emailparametersApi } from "api";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useEmailParameters = (skip: number, limit: number, searchPhrase: string = "") => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.EMAIL_PARAMETERS(skip, limit, searchPhrase),
    queryFn: () => emailparametersApi.fetch(skip, limit, searchPhrase),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.EMAIL_PARAMETERS(skip, limit, searchPhrase),
    });
  };

  return { invalidate, isLoading, isFetching, parameters: data?.data.data ?? [], total: data?.data.total ?? 0 };
};
